import React from "react";
import styles from "./exam-schedule-board.module.css";
import dayjs from "dayjs";

const ExamScheduleBoard = ({ children, form }) => {
  const startDate = form.getValues().exam_start_date;
  const endDate = form.getValues().exam_end_date;
  const dayDiff = dayjs(endDate).diff(
    dayjs(startDate, { format: "YYYY-MM-DD" }),
    "days"
  );

  const tableHead = Array.from({ length: dayDiff + 1 }, (_, i) => {
    const day = dayjs(startDate, { format: "YYYY-MM-DD" })
      .add(i, "days")
      .format("ddd - DD/MM");
    return <th>{day}</th>;
  });

  return (
    <div className={styles.exam_schedule_board}>
      <table>
        <thead>
          <tr>{tableHead}</tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default ExamScheduleBoard;
